'use strict';

var privatePropertyAccessor = require('../../common/internal/privatePropertyAccessor');

module.exports = privatePropertyAccessor('canceled');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/function/var/_canceled.js
// module id = 298
// module chunks = 0